export const ActiveLine: React.FC = () => {
	return (
		<div className="hidden lg:block w-[3px] h-[47px] bg-primary absolute left-0 rounded-tr-xl rounded-br-xl" />
	);
};
